export const gasStations = {
  type: "FeatureCollection",
  name: "Gas_Stations",
  features: [
    {
      type: "Feature",
      properties: {
        NAME: "Georgia Avenue BP",
        ADDRESS: "7605 GEORGIA AVENUE NW",
        PHONE: 2024505846,
        SSL: "2961    0070",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_9",
        LONGITUDE: -77.02610456,
        LATITUDE: 38.98222912,
        OBJECTID: 1,
        ZIPCODE: "20012",
        MAR_ID: 253716,
        XCOORD: 397736.13,
        YCOORD: 146033.64,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{85D25BA6-04CD-461F-B8EC-E625BC442139}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02613074560712, 38.98223559701938],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Exxon",
        ADDRESS: "7401 GEORGIA AVENUE NW",
        PHONE: 2027267327,
        SSL: "2962    0025",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_10",
        LONGITUDE: -77.02592104,
        LATITUDE: 38.979662,
        OBJECTID: 2,
        ZIPCODE: "20012",
        MAR_ID: 253740,
        XCOORD: 397754.02,
        YCOORD: 145748.77,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{C53D1544-9979-4739-AFE9-CC2AEC63229F}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02592333444787, 38.97966947124872],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Takoma Metro BP",
        ADDRESS: "7000 BLAIR ROAD NW",
        PHONE: 2028827850,
        SSL: "3277    0009",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_11",
        LONGITUDE: -77.01907675,
        LATITUDE: 38.97503886,
        OBJECTID: 3,
        ZIPCODE: "20012",
        MAR_ID: 249127,
        XCOORD: 398346.95,
        YCOORD: 145235.41,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{27E805A4-A91A-41D8-9B3B-006956704111}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 10,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01907904078034, 38.97504632449449],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell",
        ADDRESS: "6419 GEORGIA AVENUE NW",
        PHONE: 2027230762,
        SSL: "2975    0006",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_12",
        LONGITUDE: -77.02705218,
        LATITUDE: 38.9681158,
        OBJECTID: 4,
        ZIPCODE: "20012",
        MAR_ID: 254024,
        XCOORD: 397655.63,
        YCOORD: 144467.06,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{7D2175B9-591D-4260-9ACA-5EB4A2452582}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 15,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02705447750924, 38.96812327150666],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Pattie's BP",
        ADDRESS: "6401 GEORGIA AVENUE NW",
        PHONE: 2022912355,
        SSL: "2975    0007",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_13",
        LONGITUDE: -77.02685856,
        LATITUDE: 38.96753185,
        OBJECTID: 5,
        ZIPCODE: "20012",
        MAR_ID: 254025,
        XCOORD: 397672.39,
        YCOORD: 144402.23,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{059A45E5-4947-4DD8-9DD5-15ADEBE3288C}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02686086013938, 38.96753931162658],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Putnam's Exxon",
        ADDRESS: "6350 GEORGIA AVENUE NW",
        PHONE: 2027239379,
        SSL: "PAR 00880229",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_14",
        LONGITUDE: -77.0278877,
        LATITUDE: 38.96683986,
        OBJECTID: 6,
        ZIPCODE: "20011",
        MAR_ID: 259632,
        XCOORD: 397583.18,
        YCOORD: 144325.44,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{9B383B28-9C0C-4957-B761-60AA3F31BF6E}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02788999429067, 38.96684732746376],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Paks BP",
        ADDRESS: "6300 GEORGIA AVENUE NW",
        PHONE: 2027265300,
        SSL: "2943    0001",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_15",
        LONGITUDE: -77.02796743,
        LATITUDE: 38.96653888,
        OBJECTID: 7,
        ZIPCODE: "20011",
        MAR_ID: 253249,
        XCOORD: 397575.26,
        YCOORD: 144299.25,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{A6098621-459A-44C7-BC3E-B0D01847CAB0}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02798129059505, 38.966611379664215],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Eastern Avenue Shell",
        ADDRESS: "6201 NEW HAMPSHIRE AVENUE NE",
        PHONE: 2028274197,
        SSL: "3730    0001",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_16",
        LONGITUDE: -77.0023996,
        LATITUDE: 38.96522933,
        OBJECTID: 8,
        ZIPCODE: "20011",
        MAR_ID: 3716,
        XCOORD: 399792.04,
        YCOORD: 144146.29,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{1AA97AAD-6ADD-4FD2-8F6B-C0EAC4F2F3F8}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00240188548139, 38.96523680166624],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Circle Exxon",
        ADDRESS: "5521 CONNECTICUT AVENUE NW",
        PHONE: 2023646364,
        SSL: "1868    0068",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_17",
        LONGITUDE: -77.07429164,
        LATITUDE: 38.9637957,
        OBJECTID: 9,
        ZIPCODE: "20015",
        MAR_ID: 264023,
        XCOORD: 393561.42,
        YCOORD: 143989.76,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{8E580D91-0F41-4CCD-A0FA-D959E44D0CA2}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.07429395084421, 38.96380316147658],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell",
        ADDRESS: "5831 GEORGIA AVENUE NW",
        PHONE: 7037506810,
        SSL: "2988    0803",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_18",
        LONGITUDE: -77.02772364,
        LATITUDE: 38.96066898,
        OBJECTID: 10,
        ZIPCODE: "20011",
        MAR_ID: 285276,
        XCOORD: 397597.19,
        YCOORD: 143640.41,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{50842C0D-EE90-47EA-8B23-46E7660FB93B}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02772593185455, 38.960676443445514],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Missouri Service Station Exxon",
        ADDRESS: "264 MISSOURI AVENUE NW",
        PHONE: 2022913914,
        SSL: "PAR 01130039",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_19",
        LONGITUDE: -77.01588673,
        LATITUDE: 38.9567416,
        OBJECTID: 11,
        ZIPCODE: "20011",
        MAR_ID: 243503,
        XCOORD: 398623.02,
        YCOORD: 143204.19,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{35A1FDFE-2539-42A3-998E-587FDFC3A4FA}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01588901975542, 38.95674906774562],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "New Hampshire Ave Shell",
        ADDRESS: "5420 NEW HAMPSHIRE AVENUE NW",
        PHONE: 2027228863,
        SSL: "3393    0873",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_20",
        LONGITUDE: -77.0099395,
        LATITUDE: 38.95632842,
        OBJECTID: 12,
        ZIPCODE: "20011",
        MAR_ID: 245909,
        XCOORD: 399138.49,
        YCOORD: 143158.25,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{067F1C87-D222-43C2-A2E6-0E7C67187E2B}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00994179209363, 38.956335885132205],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "South Dakota Exxon",
        ADDRESS: "5501 SOUTH DAKOTA AVENUE NE",
        PHONE: 2028326220,
        SSL: "3760    0021",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_21",
        LONGITUDE: -77.00058471,
        LATITUDE: 38.95601923,
        OBJECTID: 13,
        ZIPCODE: "20011",
        MAR_ID: 155992,
        XCOORD: 399949.32,
        YCOORD: 143123.88,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{6AD5CE2A-D12C-4EAF-8F4C-515F400AA932}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 26,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0005869951288, 38.95602669243397],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Connecticut Avenue Tiger Mart Exxon",
        ADDRESS: "5030 CONNECTICUT AVENUE NW",
        PHONE: 2023645145,
        SSL: "1985    0021",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_22",
        LONGITUDE: -77.07061864,
        LATITUDE: 38.95534913,
        OBJECTID: 14,
        ZIPCODE: "20008",
        MAR_ID: 301055,
        XCOORD: 393879.02,
        YCOORD: 143051.86,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{EB8DA858-5FDF-4E7C-9625-D0C1B5F100FD}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.07062094727122, 38.95535658866935],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Connecticut Avenue BP",
        ADDRESS: "5001 CONNECTICUT AVENUE NW",
        PHONE: 2022446975,
        SSL: "1986    0012",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_23",
        LONGITUDE: -77.06942813,
        LATITUDE: 38.95512481,
        OBJECTID: 15,
        ZIPCODE: "20008",
        MAR_ID: 262740,
        XCOORD: 393982.19,
        YCOORD: 143026.88,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{CF8D40DC-D2E3-4D76-90F4-D2EFC36C40C5}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0694304408387, 38.95513227515977],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Connecticut Avenue Shell",
        ADDRESS: "4940 CONNECTICUT AVENUE NW",
        PHONE: 2029660408,
        SSL: "1983    0813",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_24",
        LONGITUDE: -77.07005565,
        LATITUDE: 38.95443305,
        OBJECTID: 16,
        ZIPCODE: "20008",
        MAR_ID: 222125,
        XCOORD: 393927.74,
        YCOORD: 142950.13,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{04B24748-E1E4-48F2-8934-FA44DA3A9FE8}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.07005795683257, 38.95444051605764],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell",
        ADDRESS: "4900 WISCONSIN AVENUE NW",
        PHONE: 2022449548,
        SSL: "1671    0029",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_25",
        LONGITUDE: -77.0825525,
        LATITUDE: 38.95350939,
        OBJECTID: 17,
        ZIPCODE: "20016",
        MAR_ID: 266055,
        XCOORD: 392844.45,
        YCOORD: 142848.5,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{27D49F43-F245-4CB2-B6F8-2A874E040805}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.08255480803933, 38.95351684874894],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Valero",
        ADDRESS: "5001 GEORGIA AVENUE NW",
        PHONE: 7037506810,
        SSL: "3007    0067",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_26",
        LONGITUDE: -77.02690888,
        LATITUDE: 38.95105384,
        OBJECTID: 18,
        ZIPCODE: "20011",
        MAR_ID: 251856,
        XCOORD: 397667.49,
        YCOORD: 142573.02,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{5D306670-C3ED-4247-B99F-C95D05CA55E6}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0269111790195, 38.95106130051083],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Sunoco",
        ADDRESS: "4925 SOUTH DAKOTA AVENUE NE",
        PHONE: 2028328050,
        SSL: "3899    0079",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_27",
        LONGITUDE: -76.99243189,
        LATITUDE: 38.94964771,
        OBJECTID: 19,
        ZIPCODE: "20017",
        MAR_ID: 301164,
        XCOORD: 400656.03,
        YCOORD: 142416.61,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{1542C7A8-E783-4426-B4AF-DA41E1BA034C}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99243417659456, 38.949655169262506],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Spring Valley Exxon",
        ADDRESS: "4861 MASSACHUSETTS AVENUE NW",
        PHONE: 2023622639,
        SSL: "1499    0008",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_28",
        LONGITUDE: -77.09648317,
        LATITUDE: 38.9461231,
        OBJECTID: 20,
        ZIPCODE: "20016",
        MAR_ID: 269571,
        XCOORD: 391636.09,
        YCOORD: 142029.74,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{19E8F439-AC56-4754-BC6A-82EE10996133}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 6,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.09648548500031, 38.94613056118803],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Exxon",
        ADDRESS: "4501 14TH STREET NW",
        PHONE: 2022919485,
        SSL: "2816    0816",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_29",
        LONGITUDE: -77.03222909,
        LATITUDE: 38.94531007,
        OBJECTID: 21,
        ZIPCODE: "20011",
        MAR_ID: 255205,
        XCOORD: 397206.1,
        YCOORD: 141935.56,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{324ED399-ABAF-4D5B-9671-3DF05E20BAA3}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03223138607164, 38.94531753659167],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Tenleytown Exxon",
        ADDRESS: "4244 WISCONSIN AVENUE NW",
        PHONE: 2028442886,
        SSL: "1786    0810",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_30",
        LONGITUDE: -77.07810324,
        LATITUDE: 38.9442849,
        OBJECTID: 22,
        ZIPCODE: "20016",
        MAR_ID: 222978,
        XCOORD: 393229.23,
        YCOORD: 141824.16,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{0B2CB26C-723F-4F29-B3BE-E403F5B47F26}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 19,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.07810554902264, 38.94429236293334],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Exxon",
        ADDRESS: "4140 GEORGIA AVENUE NW",
        PHONE: 2027231841,
        SSL: "2910    0040",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_31",
        LONGITUDE: -77.0258919,
        LATITUDE: 38.94140503,
        OBJECTID: 23,
        ZIPCODE: "20011",
        MAR_ID: 284837,
        XCOORD: 397755.34,
        YCOORD: 141501.89,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{919A42D9-C891-4B3F-ABD2-79FE5002E1AA}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 14,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02589419628099, 38.94141248791767],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell Gas Station",
        ADDRESS: "4000 GEORGIA AVENUE NW",
        PHONE: 2027234000,
        SSL: "2909    0813",
        WARD: "Ward 4",
        GIS_ID: "GasStationPt_32",
        LONGITUDE: -77.02559277,
        LATITUDE: 38.94002223,
        OBJECTID: 24,
        ZIPCODE: "20011",
        MAR_ID: 223657,
        XCOORD: 397781.23,
        YCOORD: 141348.38,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{DE74CFD9-930D-44C1-9554-137EDCC2C3A3}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02559506144124, 38.940029690797196],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Cleveland Park Exxon",
        ADDRESS: "3535 CONNECTICUT AVENUE NW",
        PHONE: 2023649948,
        SSL: "2222    0805",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_33",
        LONGITUDE: -77.05854446,
        LATITUDE: 38.9365601,
        OBJECTID: 25,
        ZIPCODE: "20008",
        MAR_ID: 219266,
        XCOORD: 394924.23,
        YCOORD: 140965.37,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{1143008E-C3BC-457E-9E40-23B3BF4D95C0}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.05854676814062, 38.93656756195664],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Brookland Exxon",
        ADDRESS: "1020 MICHIGAN AVENUE NE",
        PHONE: 2025269430,
        SSL: "3885    0001",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_34",
        LONGITUDE: -76.99290255,
        LATITUDE: 38.9359673,
        OBJECTID: 26,
        ZIPCODE: "20017",
        MAR_ID: 75356,
        XCOORD: 400615.35,
        YCOORD: 140897.96,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{D508228D-5EF4-44A9-A892-4A9E671BE10D}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 20,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9929048315032, 38.93597476112694],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Columbia Heights Exxon",
        ADDRESS: "3540 14TH STREET NW",
        PHONE: 2022340026,
        SSL: "2688    0108",
        WARD: "Ward 1",
        GIS_ID: "GasStationPt_35",
        LONGITUDE: -77.03316694,
        LATITUDE: 38.93517855,
        OBJECTID: 27,
        ZIPCODE: "20010",
        MAR_ID: 234782,
        XCOORD: 397124.39,
        YCOORD: 140810.9,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{25978BE7-7ECC-44D6-BAA3-D390C77BB1D2}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 10,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03316923946605, 38.9351860066266],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell",
        ADDRESS: "3701 12TH STREET NE",
        PHONE: 2022694488,
        SSL: "3926    0062",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_36",
        LONGITUDE: -76.99087191,
        LATITUDE: 38.93479194,
        OBJECTID: 28,
        ZIPCODE: "20017",
        MAR_ID: 300854,
        XCOORD: 400791.42,
        YCOORD: 140767.5,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{AA45DB4C-17FF-46C5-9B05-117B6BAA0DB9}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99087418842585, 38.93479939724089],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell Rhode Island Ave",
        ADDRESS: "3101 RHODE ISLAND AVENUE NE",
        PHONE: 2025263992,
        SSL: "4308    0045",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_37",
        LONGITUDE: -76.9642434,
        LATITUDE: 38.93440622,
        OBJECTID: 29,
        ZIPCODE: "20018",
        MAR_ID: 287515,
        XCOORD: 403100.17,
        YCOORD: 140725.25,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{4970D5D7-4767-42F0-BA0B-36BD6349A483}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.96424566993592, 38.934413684490096],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "BP",
        ADDRESS: "3426 GEORGIA AVENUE NW",
        PHONE: 2028290969,
        SSL: "2894    0090",
        WARD: "Ward 1",
        GIS_ID: "GasStationPt_38",
        LONGITUDE: -77.02422966,
        LATITUDE: 38.93274246,
        OBJECTID: 30,
        ZIPCODE: "20010",
        MAR_ID: 242835,
        XCOORD: 397899.19,
        YCOORD: 140540.23,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{4BE02917-2C71-4A68-975F-C468E9C5C4BA}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02423195745324, 38.93274992364309],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Exxon",
        ADDRESS: "3426 18TH STREET NE",
        PHONE: 2022692495,
        SSL: "4146    0038",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_39",
        LONGITUDE: -76.97997406,
        LATITUDE: 38.93273524,
        OBJECTID: 31,
        ZIPCODE: "20018",
        MAR_ID: 34566,
        XCOORD: 401736.33,
        YCOORD: 140539.34,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{10E29DB1-4402-485A-B8B1-022E38CC4EB5}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97997634229567, 38.932742703766],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Exxon",
        ADDRESS: "3200 BLADENSBURG ROAD NE",
        PHONE: 2025290696,
        SSL: "4335    0075",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_40",
        LONGITUDE: -76.95899402,
        LATITUDE: 38.93021843,
        OBJECTID: 32,
        ZIPCODE: "20018",
        MAR_ID: 287750,
        XCOORD: 403555.51,
        YCOORD: 140260.56,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{DB7A7E1F-132E-47D7-9D37-429026440067}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95899629570944, 38.93022589043155],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Rhode Island Shell",
        ADDRESS: "1830 RHODE ISLAND AVENUE NE",
        PHONE: 2025292716,
        SSL: "4208    0028",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_41",
        LONGITUDE: -76.97761672,
        LATITUDE: 38.92875134,
        OBJECTID: 33,
        ZIPCODE: "20018",
        MAR_ID: 286501,
        XCOORD: 401940.83,
        YCOORD: 140097.14,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{57F0A122-C6F1-4439-8F6A-150AE6E06F07}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97761899411763, 38.92875880164513],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Sunoco",
        ADDRESS: "2830 SHERMAN AVENUE NW",
        PHONE: 2023320357,
        SSL: "2857    0139",
        WARD: "Ward 1",
        GIS_ID: "GasStationPt_42",
        LONGITUDE: -77.02631115,
        LATITUDE: 38.92660105,
        OBJECTID: 34,
        ZIPCODE: "20001",
        MAR_ID: 284520,
        XCOORD: 397715.03,
        YCOORD: 139857.74,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{3A463135-FB37-44CB-8015-A1DA4CA1D5B6}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0263536923613, 38.926601381888],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "12th Street Exxon",
        ADDRESS: "2800 12TH STREET NE",
        PHONE: 2022690925,
        SSL: "3874    0082",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_43",
        LONGITUDE: -76.99082565,
        LATITUDE: 38.92587695,
        OBJECTID: 35,
        ZIPCODE: "20017",
        MAR_ID: 44895,
        XCOORD: 400795.53,
        YCOORD: 139777.86,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{D814A8B9-871A-42C7-A7F7-0A2B9B3220C5}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99082793099622, 38.925884409602546],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "14th Street Crown",
        ADDRESS: "2600 14TH STREET NW",
        PHONE: 2022324976,
        SSL: "2665    0043",
        WARD: "Ward 1",
        GIS_ID: "GasStationPt_44",
        LONGITUDE: -77.03261897,
        LATITUDE: 38.92384138,
        OBJECTID: 36,
        ZIPCODE: "20009",
        MAR_ID: 234256,
        XCOORD: 397171.45,
        YCOORD: 139552.36,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{43DC5D32-2A0C-424F-B3A4-93C17118E142}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03262126744374, 38.92384883983147],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Washington Sunoco",
        ADDRESS: "2450 WISCONSIN AVENUE NW",
        PHONE: 3019724116,
        SSL: "1300    0549",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_45",
        LONGITUDE: -77.0729713,
        LATITUDE: 38.92222634,
        OBJECTID: 37,
        ZIPCODE: "20007",
        MAR_ID: 295037,
        XCOORD: 393672.16,
        YCOORD: 139375.1,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{BC8E225E-0CCB-4E54-BC52-E257ECB6E769}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.07297361114271, 38.922233792695145],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "South Dakota Shell",
        ADDRESS: "2350 SOUTH DAKOTA AVENUE NE",
        PHONE: 2025263388,
        SSL: "4371    0006",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_46",
        LONGITUDE: -76.96054641,
        LATITUDE: 38.92161602,
        OBJECTID: 38,
        ZIPCODE: "20018",
        MAR_ID: 48031,
        XCOORD: 403421.32,
        YCOORD: 139305.56,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{5D079F5B-C1FC-439C-B1DD-FC23F28C6721}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 36,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.96054867944474, 38.92162348067881],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "South Dakota Exxon",
        ADDRESS: "2300 SOUTH DAKOTA AVENUE NE",
        PHONE: 2055252516,
        SSL: "4371    0003",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_47",
        LONGITUDE: -76.95954312,
        LATITUDE: 38.92085556,
        OBJECTID: 39,
        ZIPCODE: "20018",
        MAR_ID: 286779,
        XCOORD: 403508.36,
        YCOORD: 139221.18,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{F0A31FCC-4854-4B1F-8FFE-440FE885EEFE}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95954539236413, 38.92086301511291],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Rhode Island BP",
        ADDRESS: "400 RHODE ISLAND AVENUE NE",
        PHONE: 2026354545,
        SSL: "3629    0009",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_48",
        LONGITUDE: -77.00023236,
        LATITUDE: 38.92022306,
        OBJECTID: 40,
        ZIPCODE: "20002",
        MAR_ID: 288064,
        XCOORD: 399979.85,
        YCOORD: 139150.19,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{A4C08759-66C5-48C9-A723-5108E56EC878}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0002346438023, 38.920230515431925],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Mobil",
        ADDRESS: "2210 BLADENSBURG ROAD NE",
        PHONE: 2026352424,
        SSL: "4258    0141",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_49",
        LONGITUDE: -76.97068146,
        LATITUDE: 38.92002111,
        OBJECTID: 41,
        ZIPCODE: "20018",
        MAR_ID: 50359,
        XCOORD: 402542.49,
        YCOORD: 139128.18,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{F26279CE-3C45-417E-B6A8-A2462587F8C0}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 32,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97068373156182, 38.92002856558266],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Costco Gas Station",
        ADDRESS: "2441 MARKET STREET NE",
        PHONE: 2022698540,
        SSL: "4327    0004",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_8",
        LONGITUDE: -76.950389,
        LATITUDE: 38.920392,
        OBJECTID: 42,
        ZIPCODE: "20018",
        MAR_ID: 309925,
        XCOORD: 404175,
        YCOORD: 139127.11,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{18D5C9FF-B4F7-402B-8F03-B83200452DD7}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 32,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95185856111783, 38.9200126879565],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Florida Avenue Crown",
        ADDRESS: "908 FLORIDA AVENUE NW",
        PHONE: 2022923514,
        SSL: "0360    0805",
        WARD: "Ward 1",
        GIS_ID: "GasStationPt_50",
        LONGITUDE: -77.02443549,
        LATITUDE: 38.91780411,
        OBJECTID: 43,
        ZIPCODE: "20001",
        MAR_ID: 239467,
        XCOORD: 397880.9,
        YCOORD: 138881.95,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{29C3AD08-DD08-454F-855B-BCF379CDD298}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02443778461472, 38.91781156567944],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "New York Avenue BP",
        ADDRESS: "2420 NEW YORK AVENUE NE",
        PHONE: 2025263677,
        SSL: "4373    0009",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_51",
        LONGITUDE: -76.97118272,
        LATITUDE: 38.91776185,
        OBJECTID: 44,
        ZIPCODE: "20002",
        MAR_ID: 287042,
        XCOORD: 402499.1,
        YCOORD: 138877.37,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{326E5C59-0183-4F40-9723-5FAD51BF9B30}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97118499325815, 38.91776931106475],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "New York Avenue Exxon N",
        ADDRESS: "2230 NEW YORK AVENUE NE",
        PHONE: 2025264534,
        SSL: "4263    0002",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_52",
        LONGITUDE: -76.97316054,
        LATITUDE: 38.91771476,
        OBJECTID: 45,
        ZIPCODE: "20002",
        MAR_ID: 286747,
        XCOORD: 402327.58,
        YCOORD: 138872.09,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{06423BDB-62BA-4C51-96C7-2B932940ADD0}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97316281977456, 38.91772221801512],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Brentwood Rd Shell",
        ADDRESS: "925 BRENTWOOD ROAD NE",
        PHONE: 7037506810,
        SSL: "PAR 01300035",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_53",
        LONGITUDE: -76.99287924,
        LATITUDE: 38.91755737,
        OBJECTID: 46,
        ZIPCODE: "20018",
        MAR_ID: 82673,
        XCOORD: 400617.53,
        YCOORD: 138854.3,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{2C459B61-86E3-4FA6-B200-568D56252910}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99288152488283, 38.91756482441554],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Bladensburg Exxon",
        ADDRESS: "1925 BLADENSBURG ROAD NE",
        PHONE: 2025266986,
        SSL: "4393    0013",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_54",
        LONGITUDE: -76.97221679,
        LATITUDE: 38.91696523,
        OBJECTID: 47,
        ZIPCODE: "20002",
        MAR_ID: 286540,
        XCOORD: 402409.45,
        YCOORD: 138788.91,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{DE33483A-C8D1-48DC-BD11-ACEE03F4A03A}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97221906381019, 38.916972684391105],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Parkway Shell",
        ADDRESS: "1765 NEW YORK AVENUE NE",
        PHONE: 2022693040,
        SSL: "4099    0829",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_55",
        LONGITUDE: -76.97917584,
        LATITUDE: 38.91689046,
        OBJECTID: 48,
        ZIPCODE: "20002",
        MAR_ID: 286472,
        XCOORD: 401805.94,
        YCOORD: 138780.45,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{27CC9818-1A64-463C-A9DD-DCF5FC101072}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 28,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97917812272016, 38.91689792102872],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Freedom Citgo",
        ADDRESS: "1905 9TH STREET NE",
        PHONE: 2028328930,
        SSL: "3863    0008",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_56",
        LONGITUDE: -76.99327022,
        LATITUDE: 38.9167443,
        OBJECTID: 49,
        ZIPCODE: "20018",
        MAR_ID: 54411,
        XCOORD: 400583.63,
        YCOORD: 138764.04,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{4EC79184-031A-4341-BB1D-A4C65EA06C83}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 20,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99327250362782, 38.91675175550519],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Sunoco",
        ADDRESS: "1442 U STREET NW",
        PHONE: 2022652444,
        SSL: "0205    0066",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_57",
        LONGITUDE: -77.03387536,
        LATITUDE: 38.91673264,
        OBJECTID: 50,
        ZIPCODE: "20009",
        MAR_ID: 279190,
        XCOORD: 397062.21,
        YCOORD: 138763.27,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{1BC038AC-48B6-4B98-BAD3-7557B2BFA1CC}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.03387765136583, 38.916740101123956],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Exxon Gas Station",
        ADDRESS: "1601 NEW YORK AVENUE NE",
        PHONE: 2022691886,
        SSL: "PAR 01530144",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_58",
        LONGITUDE: -76.98104358,
        LATITUDE: 38.91662954,
        OBJECTID: 51,
        ZIPCODE: "20002",
        MAR_ID: 286332,
        XCOORD: 401643.97,
        YCOORD: 138751.45,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{A831D2A0-6B6D-4E0B-A522-B252AC7784ED}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98104585629191, 38.91663699722244],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Parker's Exxon",
        ADDRESS: "4812 MACARTHUR BOULEVARD NW",
        PHONE: 2023373144,
        SSL: "1388    0838",
        WARD: "Ward 3",
        GIS_ID: "GasStationPt_59",
        LONGITUDE: -77.09608652,
        LATITUDE: 38.91630015,
        OBJECTID: 52,
        ZIPCODE: "20007",
        MAR_ID: 284961,
        XCOORD: 391666.99,
        YCOORD: 138719.1,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{7B527997-C699-4DC6-9161-44E98E9EEA09}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.09608883399059, 38.916307604988646],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "New York Ave Mobil",
        ADDRESS: "1230 NEW YORK AVENUE NE",
        PHONE: 2022691638,
        SSL: "4035    0024",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_60",
        LONGITUDE: -76.98876416,
        LATITUDE: 38.91466798,
        OBJECTID: 53,
        ZIPCODE: "20002",
        MAR_ID: 285959,
        XCOORD: 400974.44,
        YCOORD: 138533.59,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{31FCA8A8-5259-4393-B5D5-D6F5D2430002}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 9,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98876643838814, 38.91467543855105],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "18th Street Shell",
        ADDRESS: "1800 18TH STREET NW",
        PHONE: 2022692495,
        SSL: "0132    0233",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_61",
        LONGITUDE: -77.04190096,
        LATITUDE: 38.91435256,
        OBJECTID: 54,
        ZIPCODE: "20009",
        MAR_ID: 241151,
        XCOORD: 396366.08,
        YCOORD: 138499.35,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{1D8FCE57-F58D-471A-B059-3FD180DF3C02}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 10,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04190325975834, 38.914360018598636],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Rhode Island Avenue Exxon",
        ADDRESS: "306 RHODE ISLAND AVENUE NW",
        PHONE: 2022342973,
        SSL: "3097    0060",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_62",
        LONGITUDE: -77.01606621,
        LATITUDE: 38.91406305,
        OBJECTID: 55,
        ZIPCODE: "20001",
        MAR_ID: 230006,
        XCOORD: 398606.63,
        YCOORD: 138466.5,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{20DD6A09-5F69-443A-A3A1-D949E8C39398}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0160684947883, 38.91407050388987],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "New York Avenue Shell",
        ADDRESS: "1231 NEW YORK AVENUE NE",
        PHONE: 2028321777,
        SSL: "4041    0825",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_63",
        LONGITUDE: -76.98858334,
        LATITUDE: 38.9140572,
        OBJECTID: 56,
        ZIPCODE: "20002",
        MAR_ID: 70390,
        XCOORD: 400990.13,
        YCOORD: 138465.79,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{77535CBB-B0FF-4200-92B6-FA75F2E87F38}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98858562152049, 38.91406465578952],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "New Jersey Avenue Marathon",
        ADDRESS: "1739 NEW JERSEY AVENUE NW",
        PHONE: 2026676165,
        SSL: "0507    0094",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_64",
        LONGITUDE: -77.01730021,
        LATITUDE: 38.91366101,
        OBJECTID: 57,
        ZIPCODE: "20001",
        MAR_ID: 237208,
        XCOORD: 398499.6,
        YCOORD: 138421.89,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{CE856CB8-7A3B-4860-B20B-A8D0885E8E2E}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 38,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01730250341407, 38.91366846570476],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Rhode Island Ave Valero",
        ADDRESS: "420 RHODE ISLAND AVENUE NW",
        PHONE: 7037506810,
        SSL: "0508    0068",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_65",
        LONGITUDE: -77.01817009,
        LATITUDE: 38.9133082,
        OBJECTID: 58,
        ZIPCODE: "20001",
        MAR_ID: 300859,
        XCOORD: 398424.15,
        YCOORD: 138382.74,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{319F8499-62CD-4DD1-9056-93D5AEDE9BCD}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01817238254634, 38.91331565719025],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Exxon",
        ADDRESS: "22 FLORIDA AVENUE NW",
        PHONE: 7037506820,
        SSL: "0614    0114",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_66",
        LONGITUDE: -77.01078957,
        LATITUDE: 38.91133386,
        OBJECTID: 59,
        ZIPCODE: "20001",
        MAR_ID: 301035,
        XCOORD: 399064.22,
        YCOORD: 138163.47,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{5C477F9F-3B3D-4085-B506-86D6C557B4E8}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.01079185413792, 38.9113413133103],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Georgetown Exxon",
        ADDRESS: "1601 WISCONSIN AVENUE NW",
        PHONE: 2023330538,
        SSL: "1280    1002",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_67",
        LONGITUDE: -77.06472026,
        LATITUDE: 38.91073828,
        OBJECTID: 60,
        ZIPCODE: "20007",
        MAR_ID: 272965,
        XCOORD: 394386.76,
        YCOORD: 138099.29,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{0C7D9E20-3A55-41A1-B6E9-D78FA80CDED0}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 26,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.06472256522596, 38.910745729324205],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Kenilworth BP",
        ADDRESS: "1535 KENILWORTH AVENUE NE",
        PHONE: 2023993418,
        SSL: "5165    0802",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_68",
        LONGITUDE: -76.93491393,
        LATITUDE: 38.91057331,
        OBJECTID: 61,
        ZIPCODE: "20019",
        MAR_ID: 60958,
        XCOORD: 405644.98,
        YCOORD: 138081,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{5821FAB8-8ACE-4363-9CC4-4165A17401BC}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.93491619354714, 38.91058076832852],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell Gas Station",
        ADDRESS: "1576 WISCONSIN AVENUE NW",
        PHONE: 2029651999,
        SSL: "1272    0816",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_69",
        LONGITUDE: -77.06533968,
        LATITUDE: 38.91052011,
        OBJECTID: 62,
        ZIPCODE: "20007",
        MAR_ID: 272739,
        XCOORD: 394333.02,
        YCOORD: 138075.11,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{7ADC6293-7C71-47E2-A56A-42CA51705793}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.06534198405414, 38.910527562765395],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "West Virginia Ave Valero",
        ADDRESS: "1801 WEST VIRGINIA AVENUE NE",
        PHONE: 2026352398,
        SSL: "4092    0006",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_70",
        LONGITUDE: -76.98512507,
        LATITUDE: 38.91044933,
        OBJECTID: 63,
        ZIPCODE: "20002",
        MAR_ID: 55987,
        XCOORD: 401290.12,
        YCOORD: 138065.33,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{A57D10E3-5B53-4D80-BE73-DEBFB04953DC}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98512734847236, 38.91045678684241],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Florida Avenue Mobil",
        ADDRESS: "45 FLORIDA AVENUE NE",
        PHONE: 2025297400,
        SSL: "0668    0090",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_71",
        LONGITUDE: -77.00746761,
        LATITUDE: 38.90983711,
        OBJECTID: 64,
        ZIPCODE: "20002",
        MAR_ID: 288234,
        XCOORD: 399352.32,
        YCOORD: 137997.29,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{3500ADCD-3A4E-413E-BB89-90A3B10AA6DB}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00746989616532, 38.90984456651669],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Mobil",
        ADDRESS: "1329 KENILWORTH AVENUE NE",
        PHONE: 2026292579,
        SSL: "5118    0019",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_7",
        LONGITUDE: -76.936971,
        LATITUDE: 38.908181,
        OBJECTID: 65,
        ZIPCODE: "20019",
        MAR_ID: 300562,
        XCOORD: 405466.979,
        YCOORD: 137815.515,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{37839AD0-DF8A-4430-B9B3-58DB76363482}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9369706411238, 38.9081903135626],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Sunoco",
        ADDRESS: "1317 9TH STREET NW",
        PHONE: 2022348411,
        SSL: "0399    0067",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_72",
        LONGITUDE: -77.0235255,
        LATITUDE: 38.90777621,
        OBJECTID: 66,
        ZIPCODE: "20001",
        MAR_ID: 239903,
        XCOORD: 397959.53,
        YCOORD: 137768.75,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{30E54D16-36B2-4123-B595-D2C28EA1E97E}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02352778765281, 38.90778366869933],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Bladensburg Rd Valero",
        ADDRESS: "1301 BLADENSBURG ROAD NE",
        PHONE: 7037506810,
        SSL: "PAR 01520033",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_73",
        LONGITUDE: -76.97813366,
        LATITUDE: 38.90756232,
        OBJECTID: 67,
        ZIPCODE: "20002",
        MAR_ID: 300661,
        XCOORD: 401896.57,
        YCOORD: 137744.97,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{8634FE08-F627-4118-A7DE-C754981BD25F}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 10,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97813593429862, 38.907569774169566],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Falcon Fuel",
        ADDRESS: "1301 13TH STREET NW",
        PHONE: 2022653005,
        SSL: "0280    0027",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_74",
        LONGITUDE: -77.02935778,
        LATITUDE: 38.90749717,
        OBJECTID: 68,
        ZIPCODE: "20005",
        MAR_ID: 240902,
        XCOORD: 397453.66,
        YCOORD: 137737.92,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{1EC0F961-64C8-4194-B9B9-9FF757B477B5}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 17,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0293600775192, 38.907504621181545],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Florida Avenue Marathon",
        ADDRESS: "520 FLORIDA AVENUE NE",
        PHONE: 2025476441,
        SSL: "3590    0014",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_75",
        LONGITUDE: -76.99899246,
        LATITUDE: 38.90678955,
        OBJECTID: 69,
        ZIPCODE: "20002",
        MAR_ID: 277678,
        XCOORD: 400116.36,
        YCOORD: 137641.11,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{480C5900-F460-44D6-A844-D484ECE32C2E}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 34,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99866073834939, 38.90663620478178],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Bladensburg Shell",
        ADDRESS: "1201 BLADENSBURG ROAD NE",
        PHONE: 2023960545,
        SSL: "4444    0012",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_76",
        LONGITUDE: -76.97936527,
        LATITUDE: 38.90583474,
        OBJECTID: 70,
        ZIPCODE: "20002",
        MAR_ID: 285912,
        XCOORD: 401795.7,
        YCOORD: 137551.44,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{2B731554-018B-4BBE-9632-BA46D2780B4B}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97929941264243, 38.90582660017335],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "M Street Exxon",
        ADDRESS: "2150 M STREET NW",
        PHONE: 2022961907,
        SSL: "0071    0819",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_77",
        LONGITUDE: -77.04846502,
        LATITUDE: 38.90497297,
        OBJECTID: 71,
        ZIPCODE: "20037",
        MAR_ID: 279561,
        XCOORD: 395796.25,
        YCOORD: 137458.42,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{FAD98EA7-4DB5-410A-9CE5-788607CA5187}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04846732027988, 38.90498042272632],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Crown",
        ADDRESS: "4200 NANNIE HELEN BURROUGHS AVENUE NE",
        PHONE: 2023991191,
        SSL: "5096    0048",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_6",
        LONGITUDE: -76.941927,
        LATITUDE: 38.902023,
        OBJECTID: 72,
        ZIPCODE: "20019",
        MAR_ID: 288132,
        XCOORD: 405037.642,
        YCOORD: 137131.231,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{4B16D702-3AF5-460B-A083-C1DB56FBDF45}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.94192570799592, 38.90202860907985],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Bladensburg Road Mobil",
        ADDRESS: "814 BLADENSBURG ROAD NE",
        PHONE: 2026352424,
        SSL: "4072    0100",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_78",
        LONGITUDE: -76.9830541,
        LATITUDE: 38.90112442,
        OBJECTID: 73,
        ZIPCODE: "20002",
        MAR_ID: 288979,
        XCOORD: 401469.93,
        YCOORD: 137030.22,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{729836C7-A505-4E02-A4BF-CC9B7E44CFE1}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98305637470199, 38.901131870663626],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Exxon Northeast Mart",
        ADDRESS: "1396 FLORIDA AVENUE NE",
        PHONE: 7037506820,
        SSL: "4068    0178",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_79",
        LONGITUDE: -76.98536888,
        LATITUDE: 38.9011123,
        OBJECTID: 74,
        ZIPCODE: "20002",
        MAR_ID: 286118,
        XCOORD: 401269.14,
        YCOORD: 137028.84,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{6FD3CF0C-56BF-424D-B513-A4EE654E1E90}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98537116025844, 38.9011197518761],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Minnesota Avenue Exxon",
        ADDRESS: "4100 HUNT PLACE NE",
        PHONE: 2023983125,
        SSL: "5076    0058",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_80",
        LONGITUDE: -76.94338941,
        LATITUDE: 38.90088609,
        OBJECTID: 75,
        ZIPCODE: "20019",
        MAR_ID: 288109,
        XCOORD: 404907.461,
        YCOORD: 137006.235,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{06518C91-8621-4CEC-83F4-5E99DC0B9DCC}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.94342739534714, 38.9009033369605],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell",
        ADDRESS: "4321 NANNIE HELEN BURROUGHS AVENUE NE",
        PHONE: 3013985156,
        SSL: "5094    0814",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_81",
        LONGITUDE: -76.94016743,
        LATITUDE: 38.90065837,
        OBJECTID: 76,
        ZIPCODE: "20019",
        MAR_ID: 288163,
        XCOORD: 405190.06,
        YCOORD: 136980.05,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{763CC9F2-FA1C-4B85-8AD0-EB935CB1BC46}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.94016969620114, 38.90066583012729],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Watergate Sunoco",
        ADDRESS: "2643 VIRGINIA AVENUE NW",
        PHONE: 2029656277,
        SSL: "0006    0810",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_82",
        LONGITUDE: -77.05571246,
        LATITUDE: 38.90049664,
        OBJECTID: 77,
        ZIPCODE: "20037",
        MAR_ID: 279605,
        XCOORD: 395165.42,
        YCOORD: 136964.7,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{989E067E-561E-42B3-8459-1ADE77120E57}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 4,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.05573668259427, 38.9005295745086],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Watergate Mobil",
        ADDRESS: "2708 VIRGINIA AVENUE NW",
        PHONE: 7037506814,
        SSL: "0002    0803",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_83",
        LONGITUDE: -77.05665619,
        LATITUDE: 38.90038899,
        OBJECTID: 78,
        ZIPCODE: "20037",
        MAR_ID: 279611,
        XCOORD: 395085.45,
        YCOORD: 136949.97,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{AF299D9C-2A9F-4CB8-AC8E-16B352E328D1}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.05665849363054, 38.90039643790106],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell",
        ADDRESS: "1400 MARYLAND AVENUE NE",
        PHONE: 2026217230,
        SSL: "1049    0036",
        WARD: "Ward 6",
        GIS_ID: "GasStationPt_84",
        LONGITUDE: -76.98518043,
        LATITUDE: 38.89980813,
        OBJECTID: 79,
        ZIPCODE: "20002",
        MAR_ID: 286124,
        XCOORD: 401285.51,
        YCOORD: 136884.07,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{38300A3B-4686-44CF-99E1-80B1DD21911D}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 10,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98518271159978, 38.89981558790255],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Benning Road Mobil",
        ADDRESS: "1950 BENNING ROAD NE",
        PHONE: 2023998880,
        SSL: "PAR 01600022",
        WARD: "Ward 5",
        GIS_ID: "GasStationPt_85",
        LONGITUDE: -76.9744302,
        LATITUDE: 38.89882653,
        OBJECTID: 80,
        ZIPCODE: "20002",
        MAR_ID: 290018,
        XCOORD: 402220.59,
        YCOORD: 136777.01,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{FD123874-E8C3-4E93-B8A2-F3800A30D5E5}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9744033011617, 38.89884928837111],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "BP",
        ADDRESS: "5207 NANNIE HELEN BURROUGHS AVENUE NE",
        PHONE: 2023992122,
        SSL: "5220    0032",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_86",
        LONGITUDE: -76.92530886,
        LATITUDE: 38.89799019,
        OBJECTID: 81,
        ZIPCODE: "20019",
        MAR_ID: 288552,
        XCOORD: 406479.18,
        YCOORD: 136684.81,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{631BECF8-F48D-43F6-927F-0C6C89878349}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 10,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.92531112007205, 38.897997646366285],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Stadium Exxon",
        ADDRESS: "2651 BENNING ROAD NE",
        PHONE: 2023966125,
        SSL: "4518    0800",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_87",
        LONGITUDE: -76.97016232,
        LATITUDE: 38.89740544,
        OBJECTID: 82,
        ZIPCODE: "20002",
        MAR_ID: 300608,
        XCOORD: 402588.33,
        YCOORD: 136617.67,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{C214CF8D-3D03-4BC4-B0FF-F5444FC242B9}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97016459157506, 38.897412890125466],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Benning Road Shell",
        ADDRESS: "3355 BENNING ROAD NE",
        PHONE: 2023985920,
        SSL: "5003    0001",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_88",
        LONGITUDE: -76.95891381,
        LATITUDE: 38.89629057,
        OBJECTID: 83,
        ZIPCODE: "20019",
        MAR_ID: 287842,
        XCOORD: 403564.16,
        YCOORD: 136494.29,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{08CD0DE0-BC35-444B-8EA0-6A5AD62164AF}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 20,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95891608203358, 38.896298023698854],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Congressional Exxon",
        ADDRESS: "200 MASSACHUSETTS AVENUE NE",
        PHONE: 2025439456,
        SSL: "0755    0033",
        WARD: "Ward 6",
        GIS_ID: "GasStationPt_89",
        LONGITUDE: -77.00308463,
        LATITUDE: 38.89546988,
        OBJECTID: 84,
        ZIPCODE: "20002",
        MAR_ID: 286572,
        XCOORD: 399732.41,
        YCOORD: 136402.39,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{EF9F38E8-4203-477A-9116-6575A0E83792}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 15,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00308691743967, 38.89547733766241],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Minnesota Avenue Shell",
        ADDRESS: "3830 MINNESOTA AVENUE NE",
        PHONE: 2023963600,
        SSL: "5045E   0003",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_90",
        LONGITUDE: -76.95119908,
        LATITUDE: 38.89293279,
        OBJECTID: 85,
        ZIPCODE: "20019",
        MAR_ID: 301051,
        XCOORD: 404233.6,
        YCOORD: 136121.88,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{6B995B1D-46D9-48B5-8AA9-89E451DB4602}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95120134337411, 38.89294024872177],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Minnesota Avenue Citgo",
        ADDRESS: "3820 MINNESOTA AVENUE NE",
        PHONE: 2023885722,
        SSL: "5045E   0002",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_91",
        LONGITUDE: -76.95147672,
        LATITUDE: 38.89265023,
        OBJECTID: 86,
        ZIPCODE: "20019",
        MAR_ID: 30064,
        XCOORD: 404209.53,
        YCOORD: 136090.5,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{4E2F7929-408A-44CB-8D6F-975101E5D5A9}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95147899178379, 38.892657681627114],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Benning Road BP",
        ADDRESS: "4400 BENNING ROAD NE",
        PHONE: 2023961567,
        SSL: "5139    0024",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_92",
        LONGITUDE: -76.93865714,
        LATITUDE: 38.89163625,
        OBJECTID: 87,
        ZIPCODE: "20019",
        MAR_ID: 288186,
        XCOORD: 405321.74,
        YCOORD: 135978.61,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{49B9E77E-7F50-45AA-844C-E0C2EFB83AF2}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9386594068784, 38.89164370636517],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Minnesota Ave Valero",
        ADDRESS: "3710 MINNESOTA AVENUE NE",
        PHONE: 7037506810,
        SSL: "5046E   0810",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_93",
        LONGITUDE: -76.95269679,
        LATITUDE: 38.8910085,
        OBJECTID: 88,
        ZIPCODE: "20019",
        MAR_ID: 31737,
        XCOORD: 404103.78,
        YCOORD: 135908.2,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{51558ED1-F952-45EE-950D-FAFE52B13185}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 24,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95269906156686, 38.89101595533775],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "East Capitol Exxon",
        ADDRESS: "4501 BENNING ROAD NE",
        PHONE: 2023975340,
        SSL: "5085    0056",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_94",
        LONGITUDE: -76.93810906,
        LATITUDE: 38.89015553,
        OBJECTID: 89,
        ZIPCODE: "20019",
        MAR_ID: 20633,
        XCOORD: 405369.4,
        YCOORD: 135814.27,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{C7BBFA94-6C39-4099-9433-EA47956C6E9F}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.93811132178176, 38.89016298060831],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Benning Road Valero",
        ADDRESS: "4519 BENNING ROAD SE",
        PHONE: 2025831216,
        SSL: "5350    0122",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_95",
        LONGITUDE: -76.93772802,
        LATITUDE: 38.88919899,
        OBJECTID: 90,
        ZIPCODE: "20019",
        MAR_ID: 278509,
        XCOORD: 405402.784,
        YCOORD: 135704.973,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{5168494F-C04B-425B-9847-556E4013A6AF}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.93772737703016, 38.889178187767385],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Capitol Hill Exxon",
        ADDRESS: "339 PENNSYLVANIA AVENUE SE",
        PHONE: 2025474054,
        SSL: "0790    0013",
        WARD: "Ward 6",
        GIS_ID: "GasStationPt_96",
        LONGITUDE: -77.00087401,
        LATITUDE: 38.88625931,
        OBJECTID: 91,
        ZIPCODE: "20003",
        MAR_ID: 278384,
        XCOORD: 399924.17,
        YCOORD: 135379.94,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{680B73E9-9580-4E40-A602-17D4C19B91B6}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 8,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00087629747553, 38.88626676228838],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Distads BP",
        ADDRESS: "823 PENNSYLVANIA AVENUE SE",
        PHONE: 2025430200,
        SSL: "0925    0020",
        WARD: "Ward 6",
        GIS_ID: "GasStationPt_97",
        LONGITUDE: -76.99423701,
        LATITUDE: 38.8834736,
        OBJECTID: 92,
        ZIPCODE: "20003",
        MAR_ID: 280153,
        XCOORD: 400499.22,
        YCOORD: 135061.71,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{6E487A83-9808-41C3-AB69-7D794CF4C547}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 20,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9942485158716, 38.88339988589837],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "G & K Sunoco",
        ADDRESS: "1248 PENNSYLVANIA AVENUE SE",
        PHONE: 2025473123,
        SSL: "1019    0053",
        WARD: "Ward 6",
        GIS_ID: "GasStationPt_98",
        LONGITUDE: -76.98865058,
        LATITUDE: 38.88205671,
        OBJECTID: 93,
        ZIPCODE: "20003",
        MAR_ID: 69747,
        XCOORD: 400984.74,
        YCOORD: 134913.48,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{57DC377C-8720-46A3-95FA-445CBA39B758}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 14,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98865286110957, 38.8820641630786],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Penn Ave Exxon",
        ADDRESS: "1201 PENNSYLVANIA AVENUE SE",
        PHONE: 2025466146,
        SSL: "1019S   0815",
        WARD: "Ward 6",
        GIS_ID: "GasStationPt_99",
        LONGITUDE: -76.98986391,
        LATITUDE: 38.88163658,
        OBJECTID: 94,
        ZIPCODE: "20003",
        MAR_ID: 72104,
        XCOORD: 400879.47,
        YCOORD: 134866.83,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{A261A0B2-177A-4F5A-ACEB-810A0710F98C}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.98986618882556, 38.88164403328065],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Shell",
        ADDRESS: "5010 BENNING ROAD SE",
        PHONE: 2024147861,
        SSL: "5340    0068",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_5",
        LONGITUDE: -76.930914,
        LATITUDE: 38.878158,
        OBJECTID: 95,
        ZIPCODE: "20019",
        MAR_ID: 288416,
        XCOORD: 405995.249,
        YCOORD: 134482.125,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{F3F5ACB4-6A93-46BF-B84A-83F758453775}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 20,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.93090903025723, 38.87815846354153],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Citgo",
        ADDRESS: "2300 PENNSYLVANIA AVENUE SE",
        PHONE: 2025817080,
        SSL: "5556    0061",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_100",
        LONGITUDE: -76.97187133,
        LATITUDE: 38.87455268,
        OBJECTID: 96,
        ZIPCODE: "20020",
        MAR_ID: 48967,
        XCOORD: 402440.86,
        YCOORD: 134080.79,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{D8DD826C-51A8-4B85-943F-9AB636C3935B}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.9718736025066, 38.87456012740392],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Pennsylvania Avenue SE Mobil",
        ADDRESS: "2305 PENNSYLVANIA AVENUE SE",
        PHONE: 2025831679,
        SSL: "5559    0035",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_101",
        LONGITUDE: -76.97331166,
        LATITUDE: 38.87411061,
        OBJECTID: 97,
        ZIPCODE: "20020",
        MAR_ID: 300688,
        XCOORD: 402315.89,
        YCOORD: 134031.68,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{62EC43B1-31F6-4F7F-B557-EE29B9409C29}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97331393282361, 38.87411806281214],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Pennsylvania Avenue BP",
        ADDRESS: "2500 PENNSYLVANIA AVENUE SE",
        PHONE: 2025845456,
        SSL: "5553    0027",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_102",
        LONGITUDE: -76.97001601,
        LATITUDE: 38.87358228,
        OBJECTID: 98,
        ZIPCODE: "20020",
        MAR_ID: 46707,
        XCOORD: 402601.89,
        YCOORD: 133973.12,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{31AABE91-8277-4A7A-A5EC-4128AF816762}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 6,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97001828662309, 38.87358973124448],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Pennsylvania Avenue Shell",
        ADDRESS: "2501 PENNSYLVANIA AVENUE SE",
        PHONE: 2025810750,
        SSL: "5579    0063",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_103",
        LONGITUDE: -76.97058808,
        LATITUDE: 38.87298301,
        OBJECTID: 99,
        ZIPCODE: "20020",
        MAR_ID: 46734,
        XCOORD: 402552.27,
        YCOORD: 133906.58,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{202855E2-4164-4AA0-AFDB-105BBA777B76}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 10,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.97059035095079, 38.87299045757557],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "AAFES Express",
        ADDRESS: "103 4TH AVENUE SW",
        PHONE: 2025547064,
        SSL: null,
        WARD: "Ward 6",
        GIS_ID: "GasStationPt_4",
        LONGITUDE: -77.015482,
        LATITUDE: 38.871092,
        OBJECTID: 100,
        ZIPCODE: "20319",
        MAR_ID: 336018,
        XCOORD: 398657.329,
        YCOORD: 133697.452,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{3582AC36-1DA4-498D-8F1C-435C49684C06}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 18,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0154745888659, 38.871109225158015],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Fort Dupont BP",
        ADDRESS: "4101 ALABAMA AVENUE SE",
        PHONE: 2025843200,
        SSL: "5369N   0022",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_104",
        LONGITUDE: -76.94438427,
        LATITUDE: 38.87018041,
        OBJECTID: 101,
        ZIPCODE: "20019",
        MAR_ID: 278474,
        XCOORD: 404826.34,
        YCOORD: 133596.53,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{594937FF-A422-4B49-ADF0-76399902F6C5}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.94438653164336, 38.87018786246253],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Hillcrest Exxon",
        ADDRESS: "3201 PENNSYLVANIA AVENUE SE",
        PHONE: 2025814550,
        SSL: "5665N   0001",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_105",
        LONGITUDE: -76.9598275,
        LATITUDE: 38.86863541,
        OBJECTID: 102,
        ZIPCODE: "20020",
        MAR_ID: 38863,
        XCOORD: 403475.48,
        YCOORD: 133436.58,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{EAE857BA-51FA-4F5A-8781-BB1E85A421BF}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95995381094734, 38.8687533433704],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Fort Davis Exxon",
        ADDRESS: "3825 ALABAMA AVENUE SE",
        PHONE: 2025815700,
        SSL: "5522    0033",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_106",
        LONGITUDE: -76.95018661,
        LATITUDE: 38.86559496,
        OBJECTID: 103,
        ZIPCODE: "20020",
        MAR_ID: 300855,
        XCOORD: 404323.09,
        YCOORD: 133087.22,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{536AAB56-99B3-4335-9F7F-CE4F4FFB3823}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.95018887367905, 38.8656024072289],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Good Hope New & Used Tires",
        ADDRESS: "2713 GOOD HOPE ROAD SE",
        PHONE: 2027486329,
        SSL: "PAR 02140112",
        WARD: "Ward 8",
        GIS_ID: "GasStationPt_107",
        LONGITUDE: -76.96860242,
        LATITUDE: 38.86012749,
        OBJECTID: 104,
        ZIPCODE: "20020",
        MAR_ID: 287193,
        XCOORD: 402725.07,
        YCOORD: 132479.58,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{AB609A60-4F24-40BE-969E-67D0C0BDC333}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 6,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.96860468802574, 38.8601349349929],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Hillcrest BP",
        ADDRESS: "2801 ALABAMA AVENUE SE",
        PHONE: 2025831100,
        SSL: "5642    0002",
        WARD: "Ward 7",
        GIS_ID: "GasStationPt_108",
        LONGITUDE: -76.96772212,
        LATITUDE: 38.85970205,
        OBJECTID: 105,
        ZIPCODE: "20020",
        MAR_ID: 278264,
        XCOORD: 402801.49,
        YCOORD: 132432.38,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{E42041B8-F6DE-49BA-B730-3A37688583C9}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.96772438772466, 38.85970949740334],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "King Gas Station",
        ADDRESS: "2917 MARTIN LUTHER KING JR AVENUE SE",
        PHONE: 2025630223,
        SSL: "5983    0051",
        WARD: "Ward 8",
        GIS_ID: "GasStationPt_3",
        LONGITUDE: -76.997284,
        LATITUDE: 38.845969,
        OBJECTID: 106,
        ZIPCODE: "20032",
        MAR_ID: 43400,
        XCOORD: 400235.697,
        YCOORD: 130907.521,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{DAC9CA57-0AC8-4456-8385-4BAC2F1D9518}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 12,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99728717540347, 38.845977335799724],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Martin Luther King Automotive",
        ADDRESS: "3011 MARTIN LUTHER KING JR AVENUE SE",
        PHONE: 2025263600,
        SSL: "5988    0082",
        WARD: "Ward 8",
        GIS_ID: "GasStationPt_109",
        LONGITUDE: -76.99833063,
        LATITUDE: 38.84443892,
        OBJECTID: 107,
        ZIPCODE: "20032",
        MAR_ID: 301041,
        XCOORD: 400144.92,
        YCOORD: 130737.57,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{0F9358C8-A836-4796-9BF8-C4157BE7745D}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 6,
      },
      geometry: {
        type: "Point",
        coordinates: [-76.99833291416293, 38.844446361236194],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "AAFES Express",
        ADDRESS: "1311 CHAPPIE JAMES BOULEVARD SW",
        PHONE: 2025636387,
        SSL: "PAR 02490020",
        WARD: "Ward 8",
        GIS_ID: "GasStationPt_2",
        LONGITUDE: -77.016155,
        LATITUDE: 38.840531,
        OBJECTID: 108,
        ZIPCODE: "20032",
        MAR_ID: 296218,
        XCOORD: 398597.697,
        YCOORD: 130303.967,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{91FE5F81-F3E8-4AE4-80E9-5AA9D981EC82}",
        CREATED: null,
        EDITED: null,
        NUMBER_OF_PUMPS: null,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.0161548388121, 38.84053916459773],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "South Capitol Shell",
        ADDRESS: "4700 SOUTH CAPITOL STREET SE",
        PHONE: 2025620661,
        SSL: "6242    0013",
        WARD: "Ward 8",
        GIS_ID: "GasStationPt_110",
        LONGITUDE: -77.00116135,
        LATITUDE: 38.8219012,
        OBJECTID: 109,
        ZIPCODE: "20032",
        MAR_ID: 276660,
        XCOORD: 399899.15,
        YCOORD: 128235.73,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{6226A939-DC23-4784-B3B8-DBC2721DBAF4}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 16,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00116362592642, 38.821908636918785],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "South Capitol Exxon",
        ADDRESS: "4665 SOUTH CAPITOL STREET SW",
        PHONE: 7037506810,
        SSL: "6274    0001",
        WARD: "Ward 8",
        GIS_ID: "GasStationPt_1",
        LONGITUDE: -77.00222203,
        LATITUDE: 38.82142896,
        OBJECTID: 110,
        ZIPCODE: "20032",
        MAR_ID: 276658,
        XCOORD: 399807.041,
        YCOORD: 128183.31,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{4B6F34EF-3E51-4DD3-BE87-A6955350952D}",
        CREATED: null,
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 26,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.00222430058466, 38.821436397073114],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "Embassy Row Shell",
        ADDRESS: "2200 P STREET NW",
        PHONE: 2024506695,
        SSL: "0048    0007",
        WARD: "Ward 2",
        GIS_ID: "GasStationPt_111",
        LONGITUDE: -77.04915963,
        LATITUDE: 38.90930705,
        OBJECTID: 321,
        ZIPCODE: "20037",
        MAR_ID: 225947,
        XCOORD: 395736.26,
        YCOORD: 137939.57,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{D2C6DCFF-0101-44CF-B1E9-4F6DFEF88FF9}",
        CREATED: "2023-06-01T16:30:45Z",
        EDITED: "2023-08-17T16:27:56Z",
        NUMBER_OF_PUMPS: 20,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.04916193236299, 38.90931450009232],
      },
    },
    {
      type: "Feature",
      properties: {
        NAME: "The Wharf Marina",
        ADDRESS: "650 WHARF STREET SW",
        PHONE: 2025955165,
        SSL: "0473    0888",
        WARD: "Ward 6",
        GIS_ID: "GasStationPt_112",
        LONGITUDE: -77.02242196,
        LATITUDE: 38.8767846,
        OBJECTID: 323,
        ZIPCODE: "20024",
        MAR_ID: 331610,
        XCOORD: 398054.4,
        YCOORD: 134328.45,
        SE_ANNO_CAD_DATA: null,
        GLOBALID: "{FBA1F6AD-6B00-44E9-B7CB-9A9F44531322}",
        CREATED: "2023-08-17T16:27:56Z",
        EDITED: "2023-08-17T17:16:14Z",
        NUMBER_OF_PUMPS: 4,
      },
      geometry: {
        type: "Point",
        coordinates: [-77.02242424424793, 38.87679238073409],
      },
    },
  ],
};
